export function isNonEmptyHtml(v: unknown): boolean {
  if (typeof v !== 'string') return false
  const s = v.trim()
  if (!s || s.toLowerCase() === 'null' || s.toLowerCase() === 'undefined') return false
  // remove tags e checa se sobra texto visível
  const textOnly = s.replace(/<[^>]*>/g, '').trim()
  return textOnly.length > 0
}

export function isNonEmptyUrl(v: unknown): boolean {
  if (typeof v !== 'string') return false
  const s = v.trim()
  if (!s || s.toLowerCase() === 'null' || s.toLowerCase() === 'undefined') return false
  return true
}
